import axios from 'axios'
import ApiErrors from '../utilities/ApiErrors';

export default {

    async get(opciones = {}) {

        const pagina = opciones.page ?? 0;
        const cantidad = opciones.rows ?? 5000;
        const sort_nombre = opciones.sortField ?? 'id';
        const sort_orden = opciones.sortOrder ?? 1;
        const filtro = opciones.filters?.global?.value ?? '';
        const borrados = opciones.borrados ?? false;

        try {
            const { data } = await axios({ url: `/clientes/?pagina=${pagina}&cantidad=${cantidad}&sort_nombre=${sort_nombre}&sort_orden=${sort_orden}&filtro=${filtro}&borrados=${borrados}`, method: 'GET' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async getVencimientos(dias, tiempo) {
        try {
            const { data } = await axios({
                url: `/clientes/vencimientos/?dias=${dias}&tiempo=${tiempo}`,
                method: "GET",
            });
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }
    },

    async add(clienteNuevo) {

        try {
            const { data } = await axios({ url: `/clientes/`, data: clienteNuevo, method: 'POST' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async update(clienteActualizado) {

        try {
            const { data } = await axios({ url: `/clientes/${clienteActualizado.id}`, data: clienteActualizado, method: 'PUT' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async delete(clienteId) {

        try {
            await axios({ url: `/clientes/${clienteId}`, method: 'DELETE' })
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },
}
